import { Button } from "reactstrap";
import { connect } from "react-redux";
import { ListCheckIcon } from "../../constants/icons";
import "./Button.css";

const BomIssuesButton = ({ onClick, badgeCount = 0, className = "" }) => {
  return (
    <Button
      className={`bomButtons linkBtn bomIssuesBtn ${className}`.trim()}
      onClick={onClick}
    >
      <ListCheckIcon className="icon" />
      <div className="text">
        BOM Issues
        {badgeCount > 0 && (
          <span className="badge badge-danger bomIssuesBadge">{badgeCount}</span>
        )}
      </div>
    </Button>
  );
};

const mapStateToProps = (state) => ({ user: state.user });

export default connect(mapStateToProps, {})(BomIssuesButton);
